{
  "chart": {
    "empty": {
      "description": "Ingen data tilgjengelig for denne perioden.",
      "title": "Ingen data funnet"
    }
  },
  "date_picker": {
    "all_time": "Hele tiden",
    "confirm": "Bekreft",
    "current_quarter": "Inneværende kvartal",
    "date_range": "{startDate} - {endDate}",
    "last_n_days": "Siste {days} dager",
    "last_n_months": "Siste {months} måneder",
    "last_quarter": "Forrige kvartal",
    "last_year": "I fjor",
    "lifetime": "Hele perioden",
    "this_year": "I år",
    "today": "I dag"
  },
  "document_viewer": {
    "sidebar_heading": "Innholdsoversikt"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "error": {
    "title": "En feil oppstod."
  },
  "factor_indicator": {
    "average": "Gjennomsnitt",
    "bad": "Kritisk",
    "excellent": "Utmerket",
    "good": "Bra"
  },
  "gauge_chart": {
    "empty": {
      "title": "Ingen data tilgjengelig",
      "tooltip": "Din motstandsdyktighetsscore beregnes"
    }
  },
  "locale": {
    "current": "Norsk",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "Engelsk",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Tysk",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Fortsett med {provider}"
  },
  "search": {
    "no_options": "Ingen tilgjengelige alternativer.",
    "no_results": "Ingen resultater funnet.",
    "placeholder": "Søk..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Lukk forhåndsvisning",
      "open": "Utvid forhåndsvisning"
    }
  },
  "video_player": {
    "captions": "Undertekster",
    "captions_off": "Av",
    "normal_speed": "Normal",
    "playback_speed": "Avspillingshastighet"
  }
}
